import * as React from "react";
const SvgFiRrBooking = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-Booking_svg__a)">
      <path
        fill="#062147"
        d="M3.866 18.965a1 1 0 0 1-1.367.366A5.02 5.02 0 0 1-.001 15V7A5.007 5.007 0 0 1 5 2V1a1 1 0 0 1 2 0v1h7V1a1 1 0 1 1 2 0v1c2.757 0 5 2.243 5 5v8a1 1 0 1 1-2 0V9h-1a1 1 0 1 1 0-2h1c0-1.654-1.346-3-3-3H5C3.346 4 2 5.346 2 7h8a1 1 0 0 1 0 2H2v6c0 1.068.575 2.064 1.5 2.599a1 1 0 0 1 .366 1.366m16.892-.385-3.749-1.401v-5.045c0-1.516-1.076-2.834-2.503-3.066a3 3 0 0 0-2.439.673 3 3 0 0 0-1.058 2.286v7.563l-1.015-.808c-.007-.006-.016-.006-.023-.012a2.995 2.995 0 0 0-4.153.207 3 3 0 0 0 .13 4.23l.558.538c.186.18.435.28.694.28.9 0 1.342-1.095.694-1.72l-.568-.548a1.001 1.001 0 0 1 1.364-1.464l2.697 2.151a1 1 0 0 0 1.623-.782v-9.638a1.002 1.002 0 0 1 1.175-.986c.463.076.825.556.825 1.093v5.739a1 1 0 0 0 .65.937l4.399 1.644a3 3 0 0 1 1.943 2.612 1 1 0 0 0 .997.935q.033 0 .066-.002c.551-.037.969-.513.933-1.063a5 5 0 0 0-3.24-4.353"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-Booking_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrBooking;
